/*
  Saint Véra, núcleo global (agente A). Expõe window.SV (contrato: estrategia/horizon-v2/CONTRATO.md §2.2).
  Carregado com defer em todas as páginas por snippets/sv-head.liquid, que antes injeta window.SV.config.

  Como os outros módulos chamam:
    SV.on('fav:change', function (e) { e.detail.count })   // 'sv:' é opcional no nome; o ouvinte recebe o CustomEvent
    SV.cart.add({ id: variantId, quantity: 1 }, { context: 'product', target: botaoEl })
      -> dispara CartLinesUpdateEvent (o mesmo do product-form.js do Horizon) em target/document, faz POST em
         routes.cartAdd e resolve a promise do evento com o carrinho atualizado. Assim cart-icon.js, header-actions.js,
         cart-drawer.js (auto-open) e os pixels que escutam 'shopify:cart:lines-update' continuam funcionando.
      -> depois emite 'sv:cart:change' { count, cart } e atualiza [data-sv-cart-count].
*/
(function () {
  'use strict';
  if (window.SV && window.SV.__core) return;

  var SV = window.SV || {};
  var doc = document;
  var root = doc.documentElement;

  /* ---------- config (vem do sv-head; defaults só protegem páginas sem o snippet) ---------- */
  var cfg = SV.config || {};
  cfg.pixPct = typeof cfg.pixPct === 'number' ? cfg.pixPct : 5;
  cfg.installments = cfg.installments || { max: 12, interestFree: 1, monthlyRate: null, show: false };
  cfg.shipping = cfg.shipping || { freeAll: true, days: [5, 12], businessDays: true, prepDays: [0, 0], transitDays: [5, 12], maxDays: 12 };
  if (!cfg.shipping.days) cfg.shipping.days = [5, 12];
  cfg.contact = cfg.contact || {};
  cfg.routes = cfg.routes || { cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', cartUpdate: '/cart/update', search: '/search', root: '/' };
  cfg.defaultMode = cfg.defaultMode === 'dark' ? 'dark' : 'light';
  cfg.modeToggle = cfg.modeToggle !== false;
  SV.config = cfg;

  /* ---------- store: localStorage com try/catch e fallback em memória ---------- */
  var PREFIX = 'sv:';
  var mem = {};
  function lsGet(k) {
    try { return window.localStorage.getItem(PREFIX + k); } catch (e) { return Object.prototype.hasOwnProperty.call(mem, k) ? mem[k] : null; }
  }
  SV.store = {
    get: function (k, fallback) {
      var raw = lsGet(k);
      if (raw === null || raw === undefined) return fallback;
      try { return JSON.parse(raw); } catch (e) { return raw; }
    },
    set: function (k, v) {
      var raw;
      try { raw = JSON.stringify(v); } catch (e) { return false; }
      mem[k] = raw;
      try { window.localStorage.setItem(PREFIX + k, raw); return true; } catch (e) { return false; }
    },
    remove: function (k) {
      delete mem[k];
      try { window.localStorage.removeItem(PREFIX + k); } catch (e) { /* storage indisponível */ }
    }
  };

  /* ---------- eventos ---------- */
  function evName(n) { return n.indexOf('sv:') === 0 ? n : 'sv:' + n; }
  SV.on = function (evt, fn) {
    var n = evName(evt);
    doc.addEventListener(n, fn);
    return function () { doc.removeEventListener(n, fn); };
  };
  SV.emit = function (evt, detail) {
    doc.dispatchEvent(new CustomEvent(evName(evt), { detail: detail }));
  };

  /* ---------- dinheiro ---------- */
  function fmt(cents) {
    var n = Math.round(Number(cents) || 0);
    var neg = n < 0; if (neg) n = -n;
    var reais = String(Math.floor(n / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var c = n % 100;
    return (neg ? '-' : '') + 'R$ ' + reais + ',' + (c < 10 ? '0' : '') + c;
  }
  SV.money = fmt;
  SV.pix = function (cents) {
    var n = Math.round(Number(cents) || 0);
    return Math.floor((n * (100 - cfg.pixPct) + 50) / 100);
  };
  SV.installment = function (cents) {
    var i = cfg.installments;
    var n = Math.round(Number(cents) || 0);
    if (!i || !i.show || n <= 0) return null;
    var free = Math.max(1, Math.min(i.interestFree || 1, i.max));
    var rate = typeof i.monthlyRate === 'number' && i.monthlyRate > 0 ? i.monthlyRate / 100 : null;
    if (rate && i.max > free) {
      return { n: i.max, value: Math.round(n * (1 + rate * i.max) / i.max), interest: true };
    }
    if (free < 2) return null;
    return { n: free, value: Math.round(n / free), interest: false };
  };

  /* tabela completa (modal de pagamento): [{n, value, total, interest, rate}] conforme a Yampi (acréscimo simples por parcela, conferido no checkout) */
  SV.installments = function (cents) {
    var i = cfg.installments, n = Math.round(Number(cents) || 0), out = [];
    if (!i || !i.show || n <= 0) return out;
    var free = Math.max(1, Math.min(i.interestFree || 1, i.max));
    var rate = typeof i.monthlyRate === 'number' && i.monthlyRate > 0 ? i.monthlyRate / 100 : 0;
    var min = Math.round((i.minValue || 0) * 100);
    for (var k = 1; k <= i.max; k++) {
      var v, interest = k > free && rate > 0;
      if (interest) v = Math.round(n * (1 + rate * k) / k);
      else v = Math.round(n / k);
      if (k > 1 && min && v < min) break;
      out.push({ n: k, value: v, total: v * k, interest: interest, rate: interest ? i.monthlyRate : 0 });
    }
    return out;
  };

  /* ---------- modo claro/escuro ---------- */
  SV.mode = {
    get: function () {
      var cur = root.getAttribute('data-sv-mode');
      if (cur === 'dark' || cur === 'light') return cur;
      var s = cfg.modeToggle ? String(SV.store.get('mode', '')) : '';
      return /dark/.test(s) ? 'dark' : /light/.test(s) ? 'light' : cfg.defaultMode;
    },
    set: function (m) {
      m = m === 'dark' ? 'dark' : 'light';
      root.setAttribute('data-sv-mode', m);
      SV.store.set('mode', m);
      SV.emit('mode', { mode: m });
      return m;
    }
  };
  window.addEventListener('storage', function (e) {
    if (e.key === PREFIX + 'mode' && cfg.modeToggle) {
      var m = /dark/.test(e.newValue || '') ? 'dark' : 'light';
      if (m !== root.getAttribute('data-sv-mode')) { root.setAttribute('data-sv-mode', m); SV.emit('mode', { mode: m }); }
    }
  });
  if (!root.getAttribute('data-sv-mode')) root.setAttribute('data-sv-mode', SV.mode.get());

  /* ---------- favoritos ---------- */
  // lista parseada em memória: has() roda uma vez por coração; invalida em escrita local e em 'storage' de outra aba
  var favCache = null;
  function favs() { if (!favCache) { var l = SV.store.get('fav', []); favCache = Array.isArray(l) ? l : []; } return favCache; }
  window.addEventListener('storage', function (e) { if (!e.key || e.key === PREFIX + 'fav') favCache = null; }, true);
  function favSave(list, handle, active) {
    favCache = list;
    SV.store.set('fav', list);
    SV.emit('fav:change', { count: list.length, handle: handle, active: active });
  }
  SV.fav = {
    list: function () { return favs().slice(); },
    has: function (handle) { return favs().some(function (f) { return f.handle === handle; }); },
    toggle: function (item) {
      var list = favs().slice(), h = item && item.handle;
      if (!h) return false;
      var idx = list.findIndex(function (f) { return f.handle === h; });
      if (idx > -1) { list.splice(idx, 1); favSave(list, h, false); return false; }
      list.unshift({ handle: h, variantId: item.variantId || null, title: item.title || '', t: Date.now() });
      favSave(list, h, true);
      return true;
    },
    remove: function (handle) {
      var list = favs(), n = list.filter(function (f) { return f.handle !== handle; });
      if (n.length !== list.length) favSave(n, handle, false);
    }
  };

  /* ---------- perfil de medidas (cm) ---------- */
  SV.fit = {
    get: function () { var p = SV.store.get('fit', null); return p && typeof p === 'object' ? p : null; },
    set: function (profile) { SV.store.set('fit', profile); SV.emit('fit:change', { profile: profile }); },
    clear: function () { SV.store.remove('fit'); SV.emit('fit:change', { profile: null }); }
  };

  /* ---------- vistos recentemente ---------- */
  SV.recent = {
    push: function (handle) {
      if (!handle) return;
      var l = SV.recent.list().filter(function (h) { return h !== handle; });
      l.unshift(handle);
      SV.store.set('recent', l.slice(0, 12));
    },
    list: function () { var l = SV.store.get('recent', []); return Array.isArray(l) ? l : []; }
  };

  /* ---------- efeitos decorativos só depois do 1º gesto ----------
     V3-PERF: círculos, arara, tríptico e revista não disputam a CPU com o carregamento.
     Começam no 1º toque/rolagem/mouse/tecla ou 8 s depois do load. No editor do tema, na hora. */
  var gq = null;
  SV.onGesture = function (fn) {
    if (gq === false || (window.Shopify && Shopify.designMode)) { fn(); return; }
    if (gq) { gq.push(fn); return; }
    gq = [fn];
    var ev = ['pointerdown', 'pointermove', 'touchstart', 'wheel', 'scroll', 'keydown'];
    var go = function (e) {
      /* rolagem só conta se for da página (a arara e os círculos rolam trilhos por código) */
      if (e && e.type === 'scroll' && e.target !== doc && e.target !== doc.scrollingElement && !(e.target.classList && e.target.classList.contains('page-wrapper'))) return;
      if (!gq) return; var q = gq; gq = false;
      ev.forEach(function (e) { removeEventListener(e, go, true); });
      q.forEach(function (f) { try { f(); } catch (err) { console.error(err); } });
    };
    ev.forEach(function (e) { addEventListener(e, go, { passive: true, capture: true }); });
    var later = function () { setTimeout(go, 8000); };
    if (doc.readyState === 'complete') later(); else addEventListener('load', later, { once: true });
  };

  /* ---------- scroller efetivo e trava de rolagem ---------- */
  // No desktop o Horizon rola .page-wrapper (base.css, >=990px), não window.
  SV.scroller = function () {
    var w = doc.querySelector('.page-wrapper');
    if (w && /(auto|scroll)/.test(getComputedStyle(w).overflowY)) return w;
    return doc.scrollingElement || root;
  };
  var locks = 0;
  // Reaproveita o atributo [scroll-lock] do Horizon (base.css trava html e .page-wrapper).
  SV.lockScroll = function () { if (locks++ === 0) root.setAttribute('scroll-lock', ''); };
  SV.unlockScroll = function () { if (locks > 0 && --locks === 0) root.removeAttribute('scroll-lock'); };

  /* ---------- focus trap ---------- */
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type=hidden]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  // focusTrap(el, { onEscape }) -> release(). release devolve o foco ao acionador.
  SV.focusTrap = function (el, opts) {
    var prev = doc.activeElement;
    function items() {
      return Array.prototype.filter.call(el.querySelectorAll(FOCUSABLE), function (n) { return n.offsetParent !== null || n === doc.activeElement; });
    }
    function onKey(e) {
      if (e.key === 'Escape' && opts && opts.onEscape) { e.stopPropagation(); opts.onEscape(e); return; }
      if (e.key !== 'Tab') return;
      var f = items();
      if (!f.length) { e.preventDefault(); return; }
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (doc.activeElement === first || !el.contains(doc.activeElement))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (doc.activeElement === last || !el.contains(doc.activeElement))) { e.preventDefault(); first.focus(); }
    }
    el.addEventListener('keydown', onKey);
    var f0 = items()[0];
    // toque: não abrir o teclado ao abrir o diálogo — foco no container; o teclado só sobe quando a pessoa toca no campo
    var coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
    if (coarse && f0 && /^(INPUT|TEXTAREA|SELECT)$/.test(f0.tagName)) f0 = null;
    if (f0) f0.focus(); else { if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1'); el.focus({ preventScroll: true }); }
    return function release() {
      el.removeEventListener('keydown', onKey);
      if (prev && typeof prev.focus === 'function' && doc.contains(prev)) prev.focus();
    };
  };

  /* ---------- ícones (mesmo conjunto de snippets/sv-icon.liquid) ---------- */
  var ICONS = {"heart": "<path d=\"M12 21S3 15 3 8a5 5 0 0 1 9-3 5 5 0 0 1 9 3c0 7-9 13-9 13Z\"/>", "heart-filled": "<path fill=\"currentColor\" d=\"M12 21S3 15 3 8a5 5 0 0 1 9-3 5 5 0 0 1 9 3c0 7-9 13-9 13Z\"/>", "bag": "<path d=\"M5 8h14l2 13H3L5 8Z\"/><path d=\"M8 8V6a4 4 0 0 1 8 0v2\"/>", "search": "<path d=\"M10.5 4a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13Z\"/><path d=\"m15.5 15.5 5.5 5.5\"/>", "user": "<path d=\"M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z\"/><path d=\"M5 21c0-4 3-6 7-6s7 2 7 6\"/>", "menu": "<path d=\"M4 6h16M4 12h16M4 18h16\"/>", "close": "<path d=\"M6 6l12 12M18 6 6 18\"/>", "chevron-left": "<path d=\"m14 5-7 7 7 7\"/>", "chevron-right": "<path d=\"m10 5 7 7-7 7\"/>", "chevron-down": "<path d=\"m6 9 6 6 6-6\"/>", "plus": "<path d=\"M12 5v14M5 12h14\"/>", "minus": "<path d=\"M5 12h14\"/>", "zoom": "<path d=\"M10 4a6 6 0 1 0 0 12 6 6 0 0 0 0-12Z\"/><path d=\"m15 15 6 6M7 10h6M10 7v6\"/>", "share": "<path d=\"M12 15V4m0 0L8 8m4-4 4 4\"/><path d=\"M5 12v7h14v-7\"/>", "whatsapp": "<path d=\"M20.5 11.6a8.5 8.5 0 0 1-12.7 7.5L3 20.5l1.3-4.6a8.5 8.5 0 1 1 16.2-4.3Z\"/><path d=\"m8 7 2 3-1 1c1 2 2 3 4 4l1-1 3 1c0 3-3 3-6 1S6 10 8 7Z\"/>", "ruler": "<path d=\"m3 16 13-13 5 5L8 21l-5-5Zm11-9 3 3m-7 1 3 3m-7 1 3 3\"/>", "truck": "<path d=\"M2 6h12v12H2V6Zm12 4h5l3 5v3h-8M4 19a2 2 0 1 0 4 0 2 2 0 0 0-4 0Zm12 0a2 2 0 1 0 4 0 2 2 0 0 0-4 0Z\"/>", "lock": "<path d=\"M5 10h14v11H5V10Zm3 0V7a4 4 0 0 1 8 0v3M12 14v3\"/>", "return": "<path d=\"M5 7h10a6 6 0 0 1 0 12H9M9 3 5 7l4 4\"/>", "calendar": "<path d=\"M4 5h16v16H4V5Zm0 5h16M7 3v4m10-4v4\"/>", "pix": "<path d=\"M12 3l9 9-9 9-9-9 9-9Z\"/><path d=\"m12 8-4 4 4 4 4-4-4-4Z\"/>", "card": "<path d=\"M2 5h20v14H2V5Zm0 4h20M5 15h5\"/>", "sun": "<path d=\"M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z\"/><path d=\"M12 2v2m0 16v2M2 12h2m16 0h2M5 5l1.5 1.5m11 11L19 19M5 19l1.5-1.5m11-11L19 5\"/>", "moon": "<path d=\"M20 15.2A8.5 8.5 0 0 1 8.8 4a8.5 8.5 0 1 0 11.2 11.2Z\"/>", "check": "<path d=\"m4 12 5 5L20 6\"/>", "star": "<path fill=\"currentColor\" d=\"M12 3l2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.9 1-6.1L3.2 9.5l6.1-.9L12 3Z\"/>", "star-half": "<path d=\"M12 3l2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.9 1-6.1L3.2 9.5l6.1-.9L12 3Z\"/><path fill=\"currentColor\" d=\"M12 3v14l-5.4 2.9 1-6.1L3.2 9.5l6.1-.9L12 3Z\"/>", "star-empty": "<path d=\"M12 3l2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.9 1-6.1L3.2 9.5l6.1-.9L12 3Z\"/>", "info": "<path d=\"M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z\"/><path d=\"M12 11v6m0-9.5v.01\"/>"};
  SV.icon = function (name, size) {
    var inner = ICONS[name];
    if (!inner) return '';
    size = size || 24;
    return '<svg class="sv-icon sv-icon--' + name + '" width="' + size + '" height="' + size + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" focusable="false" aria-hidden="true">' + inner + '</svg>';
  };

  /* ---------- sacola ---------- */
  var cartCount = null;
  var events = null; // módulo @shopify/events (importmap do Horizon), carregado sob demanda
  function loadEvents() {
    // especificador nu depende do importmap já processado; cai para a URL direta se falhar.
    // import() fica dentro de string: o minificador do CDN da Shopify reescreve import() literal em require() (quebra no navegador).
    if (!events) {
      var dynImport;
      try { dynImport = new Function('s', 'return import(s)'); } catch (e) { dynImport = function () { return Promise.reject(e); }; }
      events = dynImport('@shopify/events').catch(function () {
        return dynImport('https://cdn.shopify.com/storefront/standard-events.js');
      }).catch(function () { return null; });
    }
    return events;
  }
  function setCount(n, cart) {
    cartCount = n;
    var els = doc.querySelectorAll('[data-sv-cart-count]');
    for (var i = 0; i < els.length; i++) { els[i].textContent = n > 0 ? String(n) : ''; els[i].hidden = n <= 0; }
    SV.emit('cart:change', { count: n, cart: cart || null });
  }
  function fetchJson(url, init) {
    return fetch(url, init).then(function (r) { return r.json().then(function (j) { j.__ok = r.ok; return j; }); });
  }
  // contagem já exibida na barra inferior (mantida por sv-nav.js); null = desconhecida ("99+", sem barra)
  function knownCount() {
    var el = doc.querySelector('[data-sv-bag-count]');
    var t = el ? el.textContent.trim() : '';
    return /^\d+$/.test(t) ? parseInt(t, 10) : null;
  }
  function cartUrl() { return (cfg.routes.cart || '/cart').replace(/\/$/, '') + '.js'; }
  SV.cart = {
    get: function () {
      return fetchJson(cartUrl(), { headers: { Accept: 'application/json' } }).then(function (c) { setCount(c.item_count, c); return c; });
    },
    count: function () {
      if (cartCount === null) {
        try {
          var s = JSON.parse(window.sessionStorage.getItem('cart-count') || 'null'); // gravado pelo cart-icon.js do Horizon
          if (s && s.value !== undefined) cartCount = parseInt(s.value, 10) || 0;
        } catch (e) { /* ignora */ }
        if (cartCount === null) { cartCount = 0; SV.cart.get().catch(function () {}); }
      }
      return cartCount;
    },
    // items: {id, quantity, properties?, selling_plan?} ou lista. opts: {context, target}
    add: function (items, opts) {
      opts = opts || {};
      items = (Array.isArray(items) ? items : [items]).map(function (i) {
        var o = { id: Number(i.id), quantity: Math.max(1, parseInt(i.quantity, 10) || 1) };
        if (i.properties) o.properties = i.properties;
        if (i.selling_plan) o.selling_plan = i.selling_plan;
        return o;
      });
      var itemCount = items.reduce(function (s, i) { return s + i.quantity; }, 0);
      var sectionIds = Array.prototype.map.call(doc.querySelectorAll('cart-items-component'), function (c) { return c.dataset.sectionId; }).filter(Boolean);

      return loadEvents().then(function (mod) {
        var Evt = mod && mod.CartLinesUpdateEvent;
        var deferred = null;
        if (Evt) {
          deferred = Evt.createPromise();
          (opts.target || doc).dispatchEvent(new Evt({
            action: 'add',
            context: opts.context || 'product',
            lines: items.map(function (i) { return { merchandiseId: String(i.id), quantity: i.quantity }; }),
            promise: deferred.promise
          }));
        }
        var body = { items: items };
        if (sectionIds.length) body.sections = sectionIds.join(',');
        return fetchJson(cfg.routes.cartAdd + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body)
        }).then(function (res) {
          var failed = !res.__ok || res.status;
          // Sucesso com contagem conhecida: resolve logo após o POST (contagem otimista); o GET reconcilia depois
          var base = failed ? null : knownCount();
          if (base !== null) {
            var guess = base + itemCount;
            setCount(guess, null);
            if (deferred) {
              deferred.resolve({
                cart: { totalQuantity: guess },
                detail: { source: 'sv-core', sourceId: 'sv-core', itemCount: itemCount, sections: res.sections, didError: false }
              });
            }
            SV.cart.get().catch(function () {});
            return { cart: { item_count: guess }, response: res };
          }
          return SV.cart.get().then(function (cart) {
            if (deferred) {
              deferred.resolve({
                cart: Evt.createCartFromAjaxResponse(cart),
                detail: { items: cart.items, source: 'sv-core', sourceId: 'sv-core', itemCount: itemCount, sections: res.sections, didError: !!failed }
              });
            }
            if (failed) {
              var err = new Error(res.description || res.message || 'cart_add_failed');
              err.response = res;
              throw err;
            }
            return { cart: cart, response: res };
          });
        }).catch(function (err) {
          if (deferred) deferred.reject(err);
          throw err;
        });
      });
    }
  };
  // Adds feitos pelo Horizon (product-form, quick-add) também mantêm contador e 'sv:cart:change'.
  loadEvents().then(function (mod) {
    var name = (mod && mod.StandardEvents && mod.StandardEvents.cartLinesUpdate) || 'shopify:cart:lines-update';
    doc.addEventListener(name, function (e) {
      if (!e.promise) return;
      e.promise.then(function (r) {
        if (r && r.detail && r.detail.source === 'sv-core') return;
        var n = r && r.cart && typeof r.cart.totalQuantity === 'number' ? r.cart.totalQuantity : null;
        if (n !== null) setCount(n, null);
      }).catch(function () {});
    });
  });

  /* ---------- prazo: fonte única (dias úteis totais, da compra à entrega) ---------- */
  // feriados nacionais de data fixa (mesma regra usada nos guias)
  var HOLIDAYS = ['01-01', '04-21', '05-01', '09-07', '10-12', '11-02', '11-15', '11-20', '12-25'];
  function isBusiness(d) {
    var w = d.getDay();
    if (w === 0 || w === 6) return false;
    var k = ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
    return HOLIDAYS.indexOf(k) < 0;
  }
  function addBusiness(d, n) {
    var r = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    while (n > 0) { r.setDate(r.getDate() + 1); if (isBusiness(r)) n--; }
    return r;
  }
  SV.ship = {
    days: function () { return cfg.shipping.days.slice(); },
    text: function () { var d = cfg.shipping.days; return d[0] + ' a ' + d[1] + ' dias úteis'; },
    addBusinessDays: addBusiness,
    window: function (from) { var f = from || new Date(), d = cfg.shipping.days; return { start: addBusiness(f, d[0]), end: addBusiness(f, d[1]) }; },
    /* último dia para comprar e receber até `target` (Date); null se já passou */
    latestOrder: function (target, from) {
      // conta para trás o prazo máximo em dias úteis antes da data (sem contar o próprio dia), como nos guias
      var today = from || new Date(), n = cfg.shipping.days[1], c = new Date(target.getFullYear(), target.getMonth(), target.getDate());
      while (n > 0) { c.setDate(c.getDate() - 1); if (isBusiness(c)) n--; }
      var t0 = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      return c < t0 ? null : c;
    }
  };

  SV.__core = true;
  window.SV = SV;
  SV.emit('ready', {});
})();
